import request from '@utils/request';
import { QueryClient, useQuery } from '@tanstack/react-query';
import { Page } from 'shared-types';

export function useGetSpaFacilitiesPage(propertyId: number, language: string, enabled = true) {
  return useQuery({
    queryKey: getSpaFacilitiesPageKey(propertyId, language),
    queryFn: () => getSpaFacilitiesPage(propertyId, language),
    enabled,
  });
}

export async function getSpaFacilitiesPage(propertyId: number, language: string) {
  const { data } = await request.get(`${propertyId}/pages/facilities/${language}`, {
    isPayloadCaseConverterDisabled: true,
  });
  return data as Page;
}

export const getSpaFacilitiesPageKey = (propertyId: number, language: string) => [
  'spaFacilitiesPage',
  propertyId,
  language,
];

export const getSpaFacilitiesPagePrefetch = (
  queryClient: QueryClient,
  propertyId: number,
  language: string
) =>
  queryClient.prefetchQuery(getSpaFacilitiesPageKey(propertyId, language), () =>
    getSpaFacilitiesPage(propertyId, language)
  );
